import React from 'react'
import { ThingHandwriting, Arrow, ContentAttach, DocumentBasic, HelpTip } from '@fs/zion-icon'
import { IconButton, Row, useOverlay, useContainerWidth, H1, Button, usePageWidth, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { SocialMenu } from '@fs/zion-social'
import HandwritingOverlay from '../../handwriting/HandwritingOverlay'
import HiddenMenu from '../hiddenMenu/HiddenMenu'
import { goBackToGive } from '../../../utils/reviewUtils'
import usePrisonAccess from '../../../../Give/hooks/usePrisonAccess'

export default function ImageHeaderBar({
  loading,
  personId,
  title,
  displayNotAPerson,
  handleNotAPerson,
  transcriptionError,
  handleTranscriptionError,
  attachToTree,
  recordDetails,
  handwriting,
  social,
  welcomeOverlay,
}) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const handwritingOverlay = useOverlay()
  const sharable = { url: 'https://www.familysearch.org/getinvolved/' }

  const pageWidth = usePageWidth()
  const isMobile = pageWidth({ default: true, md: false })

  const handleClickRecordDetails = async () => {
    window.open(`/ark:/61903/${personId}`, '_blank') || window.location.assign(`/ark:/61903/${personId}`)
  }

  const { accessFromPrison, isReady } = usePrisonAccess()

  return (
    <Row alignY="middle">
      <Separator />
      <IconButton
        Icon={Arrow}
        iconDirection="backward"
        onClick={() => goBackToGive(accessFromPrison && isReady)}
        title={t('task-viewer.get-involved-link', 'Back to Get Involved')}
        data-testid="back-to-get-invovled"
        linkName="Back To Give"
      />
      <H1 size="H5" growX>
        {title}
      </H1>
      {atWidth({
        default: (
          <Row alignX="end" growX>
            {handwriting && (
              <IconButton
                Icon={ThingHandwriting}
                title={t('task-viewer.handwriting-tooltip', 'Handwriting Examples')}
                onClick={() => handwritingOverlay.handleClick()}
                data-testid="handwriting-help"
                linkName="Handwriting Help"
              />
            )}
            <HiddenMenu
              loading={loading}
              handleClickRecordDetails={handleClickRecordDetails}
              personId={personId}
              sharable={sharable}
              notAPerson={displayNotAPerson}
              handleNotAPerson={handleNotAPerson}
              transcriptionError={transcriptionError}
              handleTranscriptionError={handleTranscriptionError}
              attachToTree={recordDetails}
              recordDetails={recordDetails}
              welcomeOverlay={welcomeOverlay}
              social={social}
            />
          </Row>
        ),
        sm: (
          <Row alignX="end" growX>
            <Button
              Icon={HelpTip}
              onClick={welcomeOverlay?.handleClick}
              data-testid="instructions-modal"
              linkName="Instructions Modal"
            >
              {t('navigation.instructions-button', 'Instructions')}
            </Button>
            {recordDetails &&
              !accessFromPrison &&
              isReady &&
              personId &&
              (isMobile ? (
                <IconButton
                  disabled={loading}
                  Icon={DocumentBasic}
                  title={t('navigation.details-button', 'Record Details')}
                  onClick={() => handleClickRecordDetails()}
                  data-testid="record-details"
                  linkName="Record Details"
                />
              ) : (
                <Button
                  disabled={loading}
                  Icon={DocumentBasic}
                  onClick={() => handleClickRecordDetails()}
                  data-testid="record-details"
                  linkName="Record Details"
                >
                  {t('navigation.details-button', 'Record Details')}
                </Button>
              ))}
            {recordDetails &&
              personId &&
              !accessFromPrison &&
              isReady &&
              (isMobile ? (
                <IconButton
                  disabled={loading}
                  Icon={ContentAttach}
                  data-testid="attach-to-tree"
                  linkName="Attach To Tree"
                  onClick={() => {
                    const ark = `/ark:/61903/${personId}`
                    window.open(`/search/linker?ark=${encodeURIComponent(ark)}&sourceType=rii`)
                  }}
                  title={t('attach.header', 'Attach To Tree')}
                />
              ) : (
                <Button
                  emphasis="medium"
                  disabled={loading}
                  Icon={ContentAttach}
                  data-testid="attach-to-tree"
                  linkName="Attach To Tree"
                  onClick={() => {
                    const ark = `/ark:/61903/${personId}`
                    window.open(`/search/linker?ark=${encodeURIComponent(ark)}&sourceType=rii`)
                  }}
                >
                  {t('attach.header', 'Attach To Tree')}
                </Button>
              ))}
            {attachToTree && personId && (
              <IconButton
                disabled={loading}
                Icon={ContentAttach}
                title={t('attach.header', 'Attach To Tree')}
                onClick={() => {
                  const ark = `/ark:/61903/${personId}`
                  window.open(`/search/linker?ark=${encodeURIComponent(ark)}&sourceType=rii`)
                }}
                data-testid="attach-to-tree"
                linkName="Attach To Tree"
              />
            )}
            {handwriting && (
              <IconButton
                Icon={ThingHandwriting}
                title={t('task-viewer.handwriting-tooltip', 'Handwriting Examples')}
                onClick={() => handwritingOverlay.handleClick()}
                data-testid="handwriting-help"
                linkName="Handwriting Help"
              />
            )}
            {social && !accessFromPrison && isReady && (
              <SocialMenu disabled={loading} sharable={sharable} useIconButton />
            )}
          </Row>
        ),
      })}
      <HandwritingOverlay {...handwritingOverlay} />
      <Separator />
    </Row>
  )
}
